import * as types from '../_actions/actionTypes'
import _ from 'lodash'

export function payrollNormalWorkHour(state = {}, action) {
    switch (action.type) {
        case types.FETCH_EMP_NORMAL_WORKHOUR:
            return {
                ...state,
                ...action.payload.payrollNormalWorkHour,
            }
        case types.FETCH_EMP_NORMAL_WORKHOUR_FAILURE:
            return state
        default:
            return state
    }
}
